<template>
  <div class='EnbMarketing'>
    <div class="cont-btn">
      <button :disabled="updating" @click="update" >
        <span v-if="!updating">Atualizar</span>
        <vue-spinner size="30" v-if="updating"/>
      </button>
    </div>
    <div class="cont">
      <div class="left">
        <pref-comp
        :label="Empresa.modelo !== 'Modelo 03' ? 'Frente de loja' : 'Frente de Site'"
        frenteloja
        frentelojaCorFundo
        frentelojaCorFonte
        slide
        slogan
        category
        />
        <enb-seo/>
        <tag-manager/>
        <div style="height: 10%;"></div>
      </div>
      <div class="right">
        <enb-maps-nets/>
        <pref-comp
        label="Banners(Lateral Loja - 200x200px)"
        banner
        v-if="Empresa.modelo !== 'Modelo 03'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PrefComp from '../Preferencia/PrefComp'
import EnbMapsNets from '../Preferencia/EnbMapsNets'
import EnbSeo from '../Preferencia/EnbSeo'
import TagManager from '../Preferencia/TagManager'
export default {
  name: 'EnbMarketing',
  components: { PrefComp, EnbMapsNets, EnbSeo, TagManager },
  data () {
    return {
      updating: false
    }
  },
  computed: {
    ...mapGetters(['Themes', 'Empresa'])
  },
  methods: {
    ...mapActions(['ChangeTheme', 'UpdatePrefComp', '_UpdatePreference', '_UpdateMapsNets', '_UpdateTagmanager', '_UpdateMetaTags']),
    update () {
      this.updating = true
      this._UpdateMapsNets({
        maps: this.Empresa.maps,
        instagram: this.Empresa.instagram,
        facebook: this.Empresa.facebook,
        whatsapp: this.Empresa.whatsapp.replace('(', '').replace(')', '').replace(' ', '').replace('-', '')
      })
      .then(() => this._UpdatePreference())
      .then(() => this._UpdateTagmanager({
        tagmanagerhead: this.Empresa.tagmanagerhead,
        tagmanagerbody: this.Empresa.tagmanagerbody
      }))
      .then(() => this._UpdateMetaTags({
        metatitle: this.Empresa.metatitle,
        metadescription: this.Empresa.metadescription
      }))
      .then(() => {
        this.updating = false
      })
    }
  }
}
</script>

<style scoped>
.EnbMarketing {
  width: 96%;
  height: 92%;
  padding: 2%;
  overflow: auto;
}

.cont-btn {
  text-align: right;
  padding-right: 2%;
}

button {
  border: 0;
  background-color: #000000;
  color: #FFFFFF;
  border-radius: 5px;
  padding: 1%;
  font-size: 16px;
  cursor: pointer
}

button:disabled {
  opacity: 0.60;
}

.cont {
  display: flex;
}

.left {
  width: 50%;
  padding: 1%;
}

.right {
  width: 50%;
  padding: 1%;
}

@media (max-width: 500px) {
  .EnbMarketing {
    height: 75%;
  }
  .cont {
    display: block;
  }
  .left {
    width: 98%;
  }
  .right {
    width: 98%;
  }
}
</style>
